import { render } from "./BoardTitle.vue?vue&type=template&id=3155b3f0&scoped=true"
import script from "./BoardTitle.vue?vue&type=script&lang=js"
export * from "./BoardTitle.vue?vue&type=script&lang=js"

import "./BoardTitle.vue?vue&type=style&index=0&id=3155b3f0&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3155b3f0"]])

export default __exports__